import { motion } from "framer-motion";

const STEPS = [
  {
    num: "01",
    title: "Kostenloses Erstgespräch",
    copy: "Wir lernen uns kennen – auf Deutsch, unverbindlich und kostenlos. Sie erzählen von Ihrem Vorhaben, wir sagen ehrlich, was möglich ist.",
  },
  {
    num: "02",
    title: "Ihr persönlicher Fahrplan",
    copy: "Visum, Unternehmensform, Umzug: Sie erhalten einen klaren Plan mit allen Schritten für Ihre Auswanderung nach Florida.",
  },
  {
    num: "03",
    title: "Umsetzung & Ankommen",
    copy: "Wir begleiten Gründung, Immigration und Relocation Schritt für Schritt – bis Sie in Florida angekommen sind.",
  },
  {
    num: "04",
    title: "Begleitung danach",
    copy: "Auch nach der Auswanderung bleiben wir an Ihrer Seite: Beratung und Unterstützung für Ihr Unternehmen und Ihren Alltag in Florida.",
  },
];

export default function Process() {
  return (
    <section
      id="ablauf"
      data-testid="process-section"
      className="border-t border-line bg-sand py-24 lg:py-32"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6 }}
              className="text-xs uppercase tracking-[0.3em] text-clay"
              data-testid="process-eyebrow"
            >
              Ablauf
            </motion.p>
            <motion.h1
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="mt-6 font-serif text-4xl leading-tight tracking-tight text-ink sm:text-5xl"
              data-testid="process-title"
            >
              In vier Schritten nach{" "}
              <span className="italic text-clay">Florida</span>
            </motion.h1>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="editorial-frame mt-12 hidden lg:block"
            >
              <img
                src="https://images.pexels.com/photos/18326885/pexels-photo-18326885.jpeg?auto=compress&cs=tinysrgb&w=1200"
                alt="Typisches Florida-Haus im Key-West-Stil mit Palmen – ankommen im neuen Zuhause in Florida"
                data-testid="process-image"
                className="aspect-[4/3] w-full object-cover"
                loading="lazy"
              />
            </motion.div>
          </div>
        </div>

        <div className="lg:col-span-8">
          <ol className="border-t border-line" data-testid="process-steps">
            {STEPS.map((step, index) => (
              <motion.li
                key={step.num}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: index * 0.08 }}
                className="flex flex-col gap-4 border-b border-line py-10 sm:flex-row sm:items-baseline sm:gap-12"
                data-testid={`process-step-${step.num}`}
              >
                <span className="font-serif text-5xl italic leading-none text-sand-accent sm:text-6xl">
                  {step.num}
                </span>
                <div>
                  <h3 className="font-serif text-2xl tracking-tight text-ink sm:text-3xl">
                    {step.title}
                  </h3>
                  <p className="mt-3 max-w-xl text-sm leading-relaxed text-ink-muted md:text-base">
                    {step.copy}
                  </p>
                </div>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
